import { render, staticRenderFns } from "./goal-card.vue?vue&type=template&id=66f6fdcd&scoped=true&"
import script from "./goal-card.vue?vue&type=script&lang=ts&"
export * from "./goal-card.vue?vue&type=script&lang=ts&"
import style0 from "./goal-card.vue?vue&type=style&index=0&id=66f6fdcd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f6fdcd",
  null
  
)

export default component.exports